import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type TelegramStatus = {
  enabled: boolean;
  on_inbound_email: boolean;
  on_purchase: boolean;
  on_error: boolean;
  bot_token_set: boolean;
  bot_token_hint: string | null;
  chat_id: string | null;
  updated_at: number | null;
};

export function useNotifications() {
  return useQuery({
    queryKey: ['platform', 'notifications'],
    queryFn: () =>
      api.get<{ telegram: TelegramStatus }>('/api/platform/settings/notifications'),
  });
}

export function useSaveTelegram() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      enabled?: boolean;
      bot_token?: string;
      chat_id?: string;
      on_inbound_email?: boolean;
      on_purchase?: boolean;
      on_error?: boolean;
    }) =>
      api.put<{ telegram: TelegramStatus }>(
        '/api/platform/settings/notifications/telegram',
        body,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform', 'notifications'] });
    },
  });
}

export function useTestTelegram() {
  return useMutation({
    mutationFn: () =>
      api.post<{ sent: boolean }>('/api/platform/settings/notifications/telegram/test'),
  });
}
